import React, { useRef, useState } from 'react';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AccessibilityDropdownStyles } from './../../common/styles/accessibilityDropdown';
import { Grid, ClickAwayListener, Grow, Paper, Popper, Box, Tooltip, Button, Icon } from '@material-ui/core';
import { ReactComponent as AccessibilityIcon } from '../../base/images/accessibility-icon.svg';
import { UtilityLinkStyles } from './../styles/utilityLinks';
import { useTranslation } from 'react-i18next';
import AccessibilityDropdownList from './AccessibilityDropDownList';
import { useAppSelector } from '../../redux-store/hook';

const AccessibilityDropdown = (): JSX.Element => {
  const { t } = useTranslation();
  const accessibilityMenuRef = useRef<HTMLButtonElement>(null);
  const [openAccessibilityMenu, setOpenAccessibilityMenu] = useState(false);
  const template = useAppSelector((state) => state.template);

  const { settings } = template;
  const { utilityBar } = settings;
  const utilityLinkClass = UtilityLinkStyles(utilityBar);

  const accessibilityDropdown = AccessibilityDropdownStyles(settings);

  const handleCloseAccessibilityMenu = (event: React.MouseEvent<Document, MouseEvent>): void => {
    if (null !== accessibilityMenuRef.current && accessibilityMenuRef.current.contains(event.currentTarget)) {
      return;
    }
    setOpenAccessibilityMenu(false);
  };

  return (
    <Box ml={2}>
      <Tooltip title="Accessibility">
        <span>
          <Button
            ref={accessibilityMenuRef}
            className={utilityLinkClass.settingsIcon}
            onClick={(): void => setOpenAccessibilityMenu(true)}
            endIcon={<FontAwesomeIcon icon={faChevronDown} />}
            startIcon={
              <Icon>
                <AccessibilityIcon className={utilityLinkClass.languageIcon} />
              </Icon>
            }>
            <Box pr={1} className={utilityLinkClass.languageTitle}>
              {t('accessibility')}
            </Box>
          </Button>
        </span>
      </Tooltip>
      <Popper
        open={openAccessibilityMenu}
        anchorEl={accessibilityMenuRef.current}
        role="listbox"
        transition
        disablePortal
        placement="bottom-end">
        {({ TransitionProps }): JSX.Element => (
          <Grow {...TransitionProps}>
            <Paper>
              <ClickAwayListener onClickAway={handleCloseAccessibilityMenu}>
                <Grid item xs={12} className={accessibilityDropdown.desktopMenuSettings}>
                  <AccessibilityDropdownList setOpenAccessibilityMenu={setOpenAccessibilityMenu} />
                </Grid>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Box>
  );
};

export default AccessibilityDropdown;
